import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="topo-dark w-full border-y border-forest-line bg-forest-deep" data-id="element-50" data-mp="1zyh2w7skw2x2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-51" data-mp="1uxjom6aovt0u">
        <h2 className="trail-underline font-display text-[30px] leading-tight text-paper sm:text-5xl" data-id="element-52" data-mp="1pzi6bnl37xqf">
          Stop building every class from scratch.{' '}
          <span className="text-ember" data-id="element-53" data-mp="1l1gbk5eau9z4">Walk in with the vivencia shaped.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-paper/80" data-id="element-54" data-mp="1g7vov9i5p2f8">
          A full year of ready-to-run classes, workshops and retreat programs,
          so you spend your energy holding the group — not planning it.
        </p>

        <div className="mt-7" data-id="element-55" data-mp="176xjonvzeov2">
          <Countdown size="sm" tone="dark" data-id="element-56" data-mp="129x9q1w0h1yo" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ember bg-ember/10 px-5 py-4 text-left" data-id="element-57" data-mp="12bi67x1vyuz6">
          <div data-id="element-58" data-mp="3ven4u1fcjqet">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-ember" data-id="element-59" data-mp="3ve3xfenbokf1">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-paper" data-id="element-60" data-mp="3lhr44hvow8kt">
              Vivencia Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-61" data-mp="3qglldfe0dp2t">
            <span className="text-[15px] text-paper/60 line-through" data-id="element-62" data-mp="i08waafx31ke">$69</span>
            <span className="font-display text-4xl leading-none text-paper" data-id="element-63" data-mp="mzbr7226nren">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-64" data-mp="81je0gk3zf3m">
          <CtaButton data-id="element-65" data-mp="d1ffo95c2ug0">Yes, I want my year of classes — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-66" data-mp="d3ie9hkjxvwc">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-67" data-mp="2xpa8t5mxyk3k">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-68" data-mp="147mi4pwvufjs" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}